import { useEffect, useState, useCallback } from 'react'
import { getClients, getInsuranceCompanies, getReferralList } from '../api/api'
import { Logger } from '../logger'
import { sortByName } from '../utils/utils'
import { useLoadingStore } from '@caradasstore/LoadingStore'

export const useClientAndInsuranceData = (ccId) => {
  const [clients, setClients] = useState([])
  const [insuranceCompanies, setInsuranceCompanies] = useState([])
  const [referralSourceList, setReferralSourceList] = useState([])
  const setLoading = useLoadingStore((state) => state.setLoading)

  const fetchClients = useCallback(async () => {
    try {
      const res = await getClients({ ccid: ccId })
      if (res?.status === 200) {
        setClients(res.data.sort(sortByName))
      }
    } catch (err) {
      Logger.error({ message: err, payload: { file: 'useClientAndInsuranceData', method: 'getClients' } })
    }
  }, [ccId])

  const fetchInsurance = useCallback(async () => {
    try {
      setLoading(true)
      const res = await getInsuranceCompanies()
      if (res?.data) {
        setInsuranceCompanies(res.data)
      }
    } catch (err) {
      Logger.error({ message: err, payload: { file: 'useClientAndInsuranceData', method: 'getInsuranceCompanies' } })
    } finally {
      setLoading(false)
    }
  }, [])

  const fetchReferralSource = useCallback(async () => {
    try {
      const referralListResponse = await getReferralList(ccId)
      if (referralListResponse?.status === 200) {
        const formattedReferralList = referralListResponse.data
          .sort((a, b) => a.company.localeCompare(b.company))
          .map((referralObj) => ({
            id: referralObj.code,
            value: referralObj.company
          }))
        setReferralSourceList(formattedReferralList)
      }
    } catch (error) {
      console.error('Error fetching referral source:', error)
    }
  }, [ccId])

  useEffect(() => {
    fetchClients()
    fetchInsurance()
  }, [fetchClients, fetchInsurance])
  const clearVehicleFields = (setFormInputValues) => {
    setFormInputValues((prevValues) => ({
      ...prevValues,
      vehicleYear: '',
      vehicleMake: '',
      vehicleModel: '',
      vehicleTrim: ''
    }))
  }

  const handleVehicleManualChange = useCallback((eventOrValue, setFormInputValues) => {
    if (eventOrValue && eventOrValue.target) {
      const { name, value } = eventOrValue.target
      setFormInputValues((prev) => ({
        ...prev,
        [name]: value
      }))
    }
  }, [])

  return {
    clients,
    insuranceCompanies,
    fetchClients,
    clearVehicleFields,
    fetchReferralSource,
    referralSourceList,
    setReferralSourceList,
    handleVehicleManualChange
  }
}
